'use client';

import { Alert, AlertDescription, AlertTitle } from '@kamio/ui/components/alert';
import { TriangleAlertIcon } from 'lucide-react';
import { useEffect, useState } from 'react';

interface FragmentError {
  error: string;
  error_code: string;
  error_description: string;
}

export function FragmentErrorHandler() {
  const [fragmentError, setFragmentError] = useState<FragmentError | null>(null);

  useEffect(() => {
    // Check if we're in the browser
    if (typeof window === 'undefined') return;

    // Parse the fragment (hash) from the URL
    const hash = window.location.hash;
    if (hash.startsWith('#')) {
      const params = new URLSearchParams(hash.substring(1));

      const error = params.get('error');
      const errorCode = params.get('error_code');
      const errorDescription = params.get('error_description');

      if (error && errorDescription) {
        setFragmentError({
          error,
          error_code: errorCode || '',
          error_description: decodeURIComponent(errorDescription.replace(/\+/g, ' ')),
        });

        // Clean up the URL by removing the fragment
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    }
  }, []);

  if (!fragmentError) return null;

  return (
    <Alert variant="destructive">
      <TriangleAlertIcon className="h-4 w-4" />
      <AlertTitle>Authentication Error</AlertTitle>
      <AlertDescription>{fragmentError.error_description}</AlertDescription>
    </Alert>
  );
}
